import type { InternalRefetchQueryDescriptor } from '@apollo/client';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import {
  GetDirectVisitorMessagesDocument,
  GetLineVisitorMessagesDocument,
  GetPatientDetailDialogDocument,
  GetPatientMessagesDocument,
  GetWebVisitorMessagesDocument,
} from '~/graphql/generated/graphql';
import {
  patientDetailDialogMessageState,
  patientDetailDialogState,
} from '~/state/partials/patient_detail_dialog/atoms';

export const useBuildRefetchQueries = () => {
  const patientDetailState = useAtomValue(patientDetailDialogState);
  const { profile } = useAtomValue(patientDetailDialogMessageState);

  const refetchQueries: InternalRefetchQueryDescriptor[] = useMemo(() => {
    const queries: InternalRefetchQueryDescriptor[] = [
      {
        query: GetPatientDetailDialogDocument,
        variables: {
          id: patientDetailState.patientId,
        },
      },
    ];

    if (profile?.type === 'DirectVisitor') {
      queries.push({
        query: GetDirectVisitorMessagesDocument,
        variables: { id: patientDetailState.patientId },
      });
    }

    if (profile?.type === 'WebVisitor') {
      queries.push({
        query: GetWebVisitorMessagesDocument,
        variables: { id: patientDetailState.patientId },
      });
    }

    if (profile?.type === 'Patient') {
      queries.push({
        query: GetPatientMessagesDocument,
        variables: { id: patientDetailState.patientId },
      });
    }

    if (profile?.type === 'LineVisitor') {
      queries.push({
        query: GetLineVisitorMessagesDocument,
        variables: { id: patientDetailState.patientId },
      });
    }

    return queries;
  }, [patientDetailState.patientId, profile?.type]);

  return refetchQueries;
};
